import React, { memo } from 'react';
import './Styles.css';
import { formatMessage } from '../../../../../Localization/formatMessage';
import CountrySelector from '../../../../CountrySelector';
import Messages from '../../../../../Localization/Messages';

const AddressCountrySelector = ({ countryList, addressState, setAddressState }) => {
  return (
    <CountrySelector
      label={formatMessage(Messages.common_country)}
      onChange={country => {
        setAddressState({
          ...addressState,
          address: {
            ...addressState.address,
            country,
          },
        });
      }}
      defaultCountryCode={addressState.address.country?.code}
      cssClasses="formatSwitcher-countrySelector"
      countryListFilled={countryList}
      isMandatory={true}
    />
  );
};

export default memo(AddressCountrySelector);
